import { MapViewType } from "src/app/model/map/map-view-type";

export const MapIcons = {
    [MapViewType.ROADMAP]: "../../../assets/icons/maptypes/roadmap.svg",
    [MapViewType.HYBRID]: "../../../assets/icons/maptypes/hybrid.svg",
    [MapViewType.SATELLITE]: "../../../assets/icons/maptypes/satellite.svg",
    [MapViewType.TERRAIN]: "../../../assets/icons/maptypes/terrain.svg",
    [MapViewType.WORLD_MAP]: "../../../assets/icons/maptypes/world-map.svg",
  } as const;
  